const baseImage = {
  _version: 1,
  name: '',
  displayName: '',
  thumbUrl: '',
  x1Url: '',
  x2Url: '',
  x3Url: '',
};

const createImage = (overrides = {}) => ({
  ...baseImage,
  ...overrides
});

const duplicateImage = image => ({ ...image });

/**
 * Returns an image item with default properties.
 */
const createDefaultImage = (image, { type = 'png'} = {}) => {
  const { name, fileName } = image;

  return createImage({
    thumbUrl: `${fileName}@thumb.${type}`,
    x1Url: `${fileName}@1x.${type}`,
    x2Url: `${fileName}@2x.${type}`,
    x3Url: `${fileName}@3x.${type}`,
    name,
    displayName: name
  });
}

module.exports = { createImage, createDefaultImage, duplicateImage };
